import styled from 'styled-components';

// passing in whether to hide margin optionally as a lot of components use this - do not want to break
export const FieldGridContainer = styled.div<{ $unit?: string; $hideMargin?: boolean }>`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(${p => p.$unit ?? '16rem'}, 1fr));
	align-items: center;
	column-gap: 2rem;
	margin-bottom: ${p => (p.$hideMargin ? 0 : '1rem')};
`;
